import { softDeleteTask } from "@app/core";
import { getServices } from "../../platform.js";
import { capSeriesAt } from "./cap-series.js";
import { upsertSingleOverride } from "./helpers.js";
import type { SeriesGet, SeriesSet } from "./types.js";
import { createOverride } from "@app/core";

export async function removeSeriesOccurrence(
  set: SeriesSet,
  get: SeriesGet,
  sourceId: string,
  occurrenceIso: string,
  mode: "single" | "following" | "all",
): Promise<void> {
  const source = get().tasks.find((t) => t.id === sourceId);
  if (!source || !source.recurrence_id) return;

  if (mode === "all") {
    const { tasks } = getServices();
    const removed = softDeleteTask(source);
    await tasks.update(removed);
    set({ tasks: get().tasks.filter((t) => t.id !== sourceId) });
    return;
  }

  if (mode === "following") {
    await capSeriesAt(set, get, sourceId, occurrenceIso);
    return;
  }

  // single — cancel just this occurrence slot
  const override = createOverride({
    recurrence_id: source.recurrence_id,
    recurrence_id_ref: occurrenceIso,
    range: "single",
    status: "cancelled",
  });
  await upsertSingleOverride(set, get, override);
}
